import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import { Button, DataTable, Dialog, IconButton, Loader } from '@clatter/ui';
import AdminContentHead from '../AdminContentHead';
import { fetchHeroImages } from '../../../store';
import HeroImageForm from './HeroImageForm';
import {
  deleteHeroImage,
  selectAllHeroimages,
} from '../../../store/hero-images.slice';
import { formatDate } from '../../../helpers';

const heroImageColumns = [
  {
    label: 'Image',
    customRender: (row) => (
      <img
        style={{ width: '100%', maxWidth: '245px' }}
        src={row?.asset?.formats?.thumbnail?.url}
        alt={row.description}
      />
    ),
    align: 'left',
  },
  {
    label: 'Description',
    name: 'description',
    align: 'left',
  },
  {
    label: 'Date added',
    name: 'createdAt',
    customRender: (row) => formatDate(row.createdAt, true),
    align: 'left',
    sortable: true,
  },
];

const HeroImages = () => {
  const [editableItem, setEditableItem] = useState(null);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchHeroImages());
  }, [dispatch]);

  const heroImages = useSelector(selectAllHeroimages);

  const loading = useSelector(
    (state) => state.heroImages.loadingStatus === 'loading',
  );

  const handleEditClick = (event) => {
    const clickedItemId = event.currentTarget?.dataset?.id;

    setEditableItem(
      (clickedItemId &&
        heroImages.find((heroImage) => heroImage.id === clickedItemId)) ||
        {},
    );
  };

  const handleDismissEdit = () => {
    setEditableItem(null);
  };

  const handleDeleteClick = (event) => {
    if (window.confirm('Are you sure you want to remove this hero image?')) {
      dispatch(deleteHeroImage(event.currentTarget.dataset.id));
    }
  };

  const isEdit = editableItem && 'asset' in editableItem;

  return (
    <>
      {loading && <Loader />}
      <AdminContentHead>
        <h1>HeroImages</h1>
        <Button onClick={handleEditClick}>Add heroImage</Button>
      </AdminContentHead>
      <div>
        <DataTable
          autofit
          columns={heroImageColumns}
          defaultSortField="createdAt"
          filterColumns={['description']}
          name="adminHeroImages"
          rows={heroImages}
          renderActionColumn={(row) => (
            <>
              <IconButton data-id={row.id} onClick={handleEditClick}>
                <EditOutlinedIcon />
              </IconButton>
              <IconButton data-id={row.id} onClick={handleDeleteClick}>
                <DeleteOutlineOutlinedIcon />
              </IconButton>
            </>
          )}
        />
      </div>
      <Dialog
        title={isEdit ? 'Edit hero image' : 'Add hero image'}
        onCloseDialog={handleDismissEdit}
        open={!!editableItem}
      >
        <HeroImageForm
          isEdit={isEdit}
          editableItem={editableItem}
          onSuccess={handleDismissEdit}
        />
      </Dialog>
    </>
  );
};

export default HeroImages;
